import React from "react";

const FormPagination = ({
   page,
   limit,
   totalForms,
   onPageChange,
   onLimitChange,
   showLimitSelector = true,
}) => {
   const totalPages = Math.ceil(totalForms / limit);

   return (
      <div className="form-pagination-container">
         {showLimitSelector && (
            <div className="pagination-limit-selector">
               <label htmlFor="limit" className="limit-label">
                  Show:
               </label>
               <select
                  id="limit"
                  className="limit-select"
                  value={limit}
                  onChange={(e) => onLimitChange(Number(e.target.value))}
               >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={50}>50</option>
               </select>
               <span className="limit-text">per page</span>
            </div>
         )}

         <nav aria-label="Forms pagination" className="pagination-nav">
            <div className="pagination-controls">
               <button
                  className="pagination-btn pagination-prev"
                  onClick={() => onPageChange(page - 1)}
                  disabled={page === 1}
                  title="Previous page"
               >
                  <i className="bi bi-chevron-left"></i>
               </button>

               <div className="pagination-info">
                  <span className="pagination-text">
                     Page {page} of {totalPages}
                  </span>
                  <span className="pagination-total">({totalForms} total forms)</span>
               </div>

               <button
                  className="pagination-btn pagination-next"
                  onClick={() => onPageChange(page + 1)}
                  disabled={page >= totalPages}
                  title="Next page"
               >
                  <i className="bi bi-chevron-right"></i>
               </button>
            </div>
         </nav>
      </div>
   );
};

export default FormPagination;
